import { motion, useAnimation } from 'framer-motion';
import SVGJSContainer, {  pathMove }  from '../../../utils/SVGJSContainer';

function DesFemmes1(  ) {
const controls = useAnimation();

  return (
    <SVGJSContainer controls={ controls }	>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="760.102"
      height="769.51"
      viewBox="0 0 760.102 769.51"
    >
      <defs>
        <linearGradient
          id="linear-gradientPromouvoir5"
          x1="0.5"
          x2="0.5"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#00849b"></stop>
          <stop offset="1" stopColor="#84bfc2"></stop>
        </linearGradient>
        <linearGradient
          id="linear-gradientPromouvoir5-2"
          x1="0.5"
          x2="0.5"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#e1ea65"></stop>
          <stop offset="1" stopColor="#689750"></stop>
        </linearGradient>
      </defs>
      <g data-name="Groupe 2554" transform="translate(-1040.883 -3458)">
        <g data-name="Groupe 2553">
          <g data-name="Groupe 2552">
            <path
              fill="#daf1e9"
              d="M0 0H750V750H0z"
              data-name="Rectangle 2315"
              transform="translate(1040.883 3477.51)"

            ></path>
            <path
              fill="url(#linear-gradientPromouvoir5)"
              d="M0 0H218.55V596.963H0z"
              data-name="Rectangle 2309"
              transform="rotate(179.987 707.704 2094.432)"

            ></path>
            <path
              fill="url(#linear-gradientPromouvoir5-2)"
              d="M0 0H229.117V521.101H0z"
              data-name="Rectangle 2311"
                transform="translate(1415.883 3667.631)"

            ></path>
            <g data-name="Groupe 2546" transform="translate(1277.789 3801.018)">
              <g data-name="Groupe 2545">
                <g data-name="Groupe 2544">
                  <motion.path
                    fill="#00849b"
                    d="M0 0H196.186V387.732H0z"
                      data-name="Rectangle 2312"
                      variants={pathMove}
                      stroke="#E1EA65"
                      strokeMiterlimit="1"
                      strokeWidth="1"
                      initial="hidden"
                      animate={ controls }
                  ></motion.path>
                </g>
              </g>
            </g>

          </g>
          <path
            fill="#daf1e9"
            d="M0 0H55V71H0z"
            data-name="Rectangle 2325"
            transform="translate(1388 4122)"
          ></path>
        </g>
      </g>
    </svg>
    </SVGJSContainer>
  );
}

export default DesFemmes1;
